import React from 'react';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/browser';
var getToastHtml = function (title, text) { return (React.createElement("span", null,
    React.createElement("h4", null, title),
    text)); };
export default (function (currentProps, nextProps) {
    var _a = currentProps.sandbox, items = _a.items, isExtending = _a.isExtending, isSharing = _a.isSharing, isTerminating = _a.isTerminating, isAcceptingInvitation = _a.isAcceptingInvitation, isDownloadingCredentials = _a.isDownloadingCredentials;
    var _b = nextProps.sandbox, isExtendingError = _b.isExtendingError, isTerminatingError = _b.isTerminatingError, isSharingError = _b.isSharingError, isAcceptingInvitationError = _b.isAcceptingInvitationError, isDownloadingCredentialsError = _b.isDownloadingCredentialsError;
    // Handle EXTEND Toast
    if (isExtending && nextProps.sandbox.isExtendingError !== null) {
        var options = {
            description: isExtendingError
                ? getToastHtml('Failed', 'Something went wrong')
                : getToastHtml('Success', 'Project extended for additional 7 days'),
            type: isExtendingError ? 'error' : 'success',
        };
        toast(options.description, options);
        if (isExtendingError)
            Sentry.captureMessage('Extend Error');
    }
    // Handle Invite Toast
    if (isSharing && nextProps.sandbox.isSharingError !== null) {
        var options = {
            description: isSharingError
                ? getToastHtml('Failed', 'Something went wrong')
                : getToastHtml('Success', 'Invition sent'),
            type: isSharingError ? 'error' : 'success',
        };
        toast(options.description, options);
        if (isSharingError)
            Sentry.captureMessage('Invitt Error');
    }
    // Handle Terminate Toast
    if (isTerminating && nextProps.sandbox.isTerminating !== null) {
        var options = {
            description: isTerminatingError
                ? getToastHtml('Failed', 'Something went wrong')
                : getToastHtml('Success', 'Project has been deleted'),
            type: isTerminatingError ? 'error' : 'success',
        };
        toast(options.description, options);
        if (isTerminatingError)
            Sentry.captureMessage('Terminating Error');
    }
    // Handle Invitation Accept
    if (isAcceptingInvitation && !nextProps.isAcceptingInvitation !== null) {
        var options = {
            description: isAcceptingInvitationError
                ? getToastHtml('Failed', 'Could not accept invitation. Incorrect invitation code.')
                : getToastHtml('Success', 'You accepted the invitation'),
            type: isAcceptingInvitationError ? 'error' : 'success',
        };
        // Show invitation toast only on success
        if (!isAcceptingInvitationError)
            toast(options.description, options);
    }
    // Handle Credentials Download
    if (isDownloadingCredentials && !nextProps.isDownloadingCredentials !== null) {
        var options = {
            description: isDownloadingCredentialsError
                ? getToastHtml('Failed', 'Could not download credentials.')
                : getToastHtml('Success', "Downloading credentials for sandbox: ".concat(items[items.length - 1].usecase_long_name)),
            type: isDownloadingCredentialsError ? 'error' : 'success',
        };
        // Show invitation toast only on success
        if (!isDownloadingCredentialsError)
            toast(options.description, options);
    }
});
